<template>
  <div>
    <Breadcrumbs main="" :title="$t('lbl_EMPBE_SourcingWall')" />
    
      <template >
        <div class="container-fluid buyer-request-iframe-wrap">
          <iframe
            v-if="iframeUrl && iframeKey"
            :key="iframeKey"
            class="buyer-request-iframe"
            :src="iframeUrl"
            frameborder="0"
          ></iframe>
        </div>
      </template>
  
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getToken } from '@/_helpers/auth-header';

export default {
  data() {
    return {
      iframeKey: 0,
      cacheBuster: Date.now(),
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    supplierToken() {
      return this.user?.token || getToken();
    },
    iframeUrl() {
      const tooken= this.user?.token || getToken();
      const lang = localStorage.getItem('currentLang') || 'simp';
      //const isUat = process.env.VUE_APP_EMP_IsUat === 'true';
      const base =process.env.VUE_APP_EMP_VIEW;
      return `${base}SupplierToken/${lang}?TargetPage=sourcingrequest&SupplierToken=${tooken}&_t=${this.cacheBuster}&resource=BackEnd`;
    },
  },
  mounted() {
    this.refreshIframe();
  },
  activated() {
    this.refreshIframe();
  },
  methods: {
    refreshIframe() {
      this.cacheBuster = Date.now();
      this.iframeKey += 1;
    },
  },
};
</script>

<style scoped>
.buyer-request-iframe-wrap {
  padding: 0;
  height: calc(100vh - 120px);
}

.buyer-request-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
#body{
  background-color: rgb(248, 248, 248)
}
</style>
